import { useCallback } from 'react';
import useEnterKey from 'hooks/useKeydown';
import { useMappedState } from "redux-react-hook";
import { useResendVerificationKeyMutation } from 'services/api/serviceApi';
import styled from 'styled-components';
import { errorAlert, successAlert } from 'ui-kit/Alert';
import Spinner from 'ui-kit/Spinner';

import Modal from "../../../ui-kit/Modal";

const EmailConfirmationModal = ({ isOpen, onClose }) => {
  const [resendVerificationKey, { isLoading }] = useResendVerificationKeyMutation();
  const {
    currentUser
  } = useMappedState(useCallback(state => {
    const currentUser = state.users.usersMap.get(state.users.currentUserId);
    return {
      currentUser: currentUser,
    };
  }, []));

  if (!currentUser || currentUser?.emailVerified) {
    return;
  }
  const handleResendEmail = async () => {
    if (isLoading) {
      return;
    }
    try {
      await resendVerificationKey({
        returnUrl: window.location.href
      }).unwrap();
      successAlert('Verification email has been sent. Please check your inbox');
    } catch (_exc) {
      errorAlert('Email has already been sent. Please check your inbox');
    }
  };

  useEnterKey('Enter', handleResendEmail);

  return (

    <Modal isOpen={isOpen} onClose={onClose} canClose={true} classname="email-confirmation-modal">
      <Wrapper>
        To continue, confirm your email
        <Button
          onClick={handleResendEmail}
          disabled={isLoading}
          autoFocus
        >
          {isLoading ? <Spinner size={20} /> : 'Resend email'}
        </Button>
      </Wrapper>
    </Modal>
  );
};

export default EmailConfirmationModal;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 18px;
`;

const Button = styled.button`
  background: ${({ disabled }) => (disabled ? "#818181" : "transparent")};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  color: ${({ disabled }) => (disabled ? "white" : "rgba(255, 126, 85, 1)")};
  border: 1px solid ${({ disabled }) => (disabled ? "#818181" : "rgba(255, 126, 85, 1)")};
  font-size: 16px;
  line-height: 20px;
  padding: 6px 12px;
  border-radius: 1000px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  min-width: 125px;
  min-height: 35px;
  :hover {
    background: ${({ disabled }) => (disabled ? "#818181" : "#ff7e55")};
    color: white;
  }

  &:focus {
    outline: none;
  }
`;